import * as React from 'react';

import { ChatMessageLayout } from '../ChatMessageLayout';

/* istanbul ignore next */
export const ChatMessageChatbotTyping = () => {
  return (
    <ChatMessageLayout
      messageUserId={0}
      isOutcoming={false}
      isUnread={false}
      isOnlyImage={false}
      isOffer={true}
      isLastInChain={true}
      isTextAndImage={false}
      isTyping={true}
      created={0}
      imagesNode={null}
      textNode={null}
      actionButtonsNode={null}
      statusNode={null}
      errorSignNode={null}
      errorTextNode={null}
      errorMenuNode={null}
      infoMessageNode={null}
      documentNode={null}
      imageAsDocumentNode={null}
      offerNode={null}
      bubblesNode={null}
    />
  );
};
